var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "c-e-icon__svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0834 8.15965C19.2909 7.94905 19.6297 7.94648 19.8403 8.15391C20.0318 8.34248 20.0513 8.63969 19.8975 8.8504L19.8461 8.91082L12.3813 16.4898C12.1907 16.6833 11.8897 16.7009 11.679 16.5425L11.6187 16.4898L4.15391 8.91082C3.94648 8.70022 3.94905 8.36134 4.15965 8.15391C4.35111 7.96533 4.64858 7.95032 4.85693 8.10737L4.91657 8.15965L12 15.3506L19.0834 8.15965Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.96e2c37e6b882f55d720e8f4c7c783d5.svg";
export { ForwardRef as ReactComponent };